import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { ExpandArrows } from '@lt/components/icons-react/map';
import styled from 'styled-components';
import { i18n } from '@lt/localization';
import { pushMapExpanded } from 'src/routes/SearchPage/components/YandexMapsSearch/analytics';

const YMapControlButton = loadReactComponent(
  'YMapControlButton',
  loadModulePromise,
);

interface FullscreenControlButtonProps {
  isExpanded: boolean;
  toggleHandler: () => void;
}

const FullscreenControlButton = (props: FullscreenControlButtonProps) => {
  const { isExpanded, toggleHandler } = props;

  const expandText = i18n.t('map.controls.expand');

  const handleClick = () => {
    toggleHandler();

    pushMapExpanded(isExpanded);
  };

  return (
    <YMapControlButton onClick={handleClick}>
      <ButtonContent>
        <Icon as={ExpandArrows} />
        <span>{expandText} </span>
      </ButtonContent>
    </YMapControlButton>
  );
};

const Icon = styled.div`
  width: 16px;
  width: 15px;
  margin-right: 8px;
`;

const ButtonContent = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`;

export default FullscreenControlButton;
